import { Typography } from "@mui/material";

const Paragraph = ({ children, noIndent, extraSx }) => (
  <Typography
    variant="body1"
    paragraph
    gutterBottom
    sx={{
      textIndent: noIndent ? "" : "2em",
      textAlign: "justify",
      alignSelf: "flex-start",
      ...extraSx,
    }}
  >
    {children}
  </Typography>
);
export default Paragraph;
